<div class="badges">
  @for (icon of iconData().slice(0, displayedIconsCount()); track icon.id) {
    <div class="badge" [style.margin-right.px]="marginRight()">
      <app-icon-badge
        matTooltipPosition="above"
        [content]="icon.content"
        [fallbackText]="icon.name"
        [borderColor]="borderColor()"
        [backgroundColor]="backgroundColor()"
        [fallbackBackgroundColor]="fallbackBackgroundColor()"
        [borderRadius]="borderRadius()"
        [borderWidth]="borderWidth()"
        [alt]="icon.alt"
        [iconSize]="iconSize()"
        [size]="size()"
        [fontSize]="fontSize()"
        [matTooltip]="icon.name"
      />
    </div>
  }

  @if (hasMoreIcons()) {
    <div class="badge-more">
      <app-icon-badge
        backgroundColor="var(--shikenso-pink-base)"
        fallbackBackgroundColor="var(--shikenso-pink-base)"
        color="var(--shikenso-purple-base)"
        matTooltipPosition="above"
        matTooltipClass="comma-break-tooltip"
        [content]="moreCreatorsCount()"
        [borderColor]="borderColor()"
        [borderRadius]="borderRadius()"
        [borderWidth]="0"
        [size]="size()"
        [iconSize]="moreCreatorsCountFontSize()"
        [shortenText]="false"
        [matTooltip]="moreCreatorsTooltip()"
      />
    </div>
  }
</div>
